'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index_es = require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
var Skeleton_web = require('../../atoms/Skeleton/Skeleton.web.cjs');
var InternalButtonLink_web = require('../InternalButtonLink/InternalButtonLink.web.cjs');
var InternalButton_web_styles = require('./InternalButton.web.styles.cjs');

// TODO: add Supernova documentation link when ready
/**
 * A styled component used as a trigger to perform a specific action. Communicates what action will occur when the button is clicked.
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/internal/InternalButton/InternalButton.web.tsx | View in GitLab}

 * @scope Core
 */ const InternalButton = ({ variant = "primary", intention = "neutral", size = "medium", isFullWidth = false, isLoading = false, children, leftIcon, rightIcon, customCss, ...rest })=>{
    const currentTheme = react.useTheme();
    const getIntentionStyles = ()=>{
        if (intention === "neutral" || intention === "inverse") {
            return InternalButton_web_styles.neutralInverseIntentions[variant](currentTheme, intention);
        }
        return InternalButton_web_styles[intention][variant];
    };
    const buttonStyles = [
        InternalButton_web_styles.base,
        getIntentionStyles(),
        InternalButton_web_styles.height(currentTheme, size),
        isFullWidth && InternalButton_web_styles.fullWidth,
        customCss
    ];
    if (isLoading) {
        return /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
            variant: "button",
            size: size,
            isFullWidth: isFullWidth
        });
    }
    return /*#__PURE__*/ jsxRuntime.jsxs(InternalButtonLink_web.InternalButtonLink, {
        css: buttonStyles,
        "data-testid": "aviary-internal-button",
        ...rest,
        children: [
            leftIcon && /*#__PURE__*/ jsxRuntime.jsx(index_es.FontAwesomeIcon, {
                icon: leftIcon,
                css: InternalButton_web_styles.icon
            }),
            children,
            rightIcon && /*#__PURE__*/ jsxRuntime.jsx(index_es.FontAwesomeIcon, {
                icon: rightIcon,
                css: InternalButton_web_styles.icon
            })
        ]
    });
};

exports.InternalButton = InternalButton;
//# sourceMappingURL=InternalButton.web.cjs.map
